import {useMemo} from 'react'
import useWebsiteId from '@hooks/useWebsiteId'
import usePreferences from '@page-components/CheckoutV3/hooks/usePreferences.main'
import {useApolloQuery as useQuery} from 'apollo-hooks'
import gql from 'graphql-tag'

import {
  CheckoutV3UpsellingItems,
  CheckoutV3UpsellingItemsVariables
} from './__generated__/CheckoutV3UpsellingItems'

export default function useUpselling() {
  const {preferences} = usePreferences()
  const websiteId = useWebsiteId()

  const menuId = useMemo(() => preferences?.menuId, [preferences?.menuId])

  const {data} = useQuery<CheckoutV3UpsellingItems, CheckoutV3UpsellingItemsVariables>({
    query: gql`
      query CheckoutV3UpsellingItems($websiteId: ID!, $menuId: ID!) {
        userPreferences(websiteId: $websiteId) {
          _id
          cart {
            upsellingOffers {
              _id
              name
              description
              image {
                _id
                url: resizedURL(width: 300, height: 300, format: "webp")
              }
              availabilityAt(menuId: $menuId) {
                finalPrice
              }
            }
          }
        }
      }
    `,
    variables: {
      websiteId,
      menuId
    },
    fetchPolicy: 'cache-first'
  })

  return data?.userPreferences?.cart?.upsellingOffers ?? []
}
